import { createAsyncThunk } from '@reduxjs/toolkit';
import { blogService } from '../services/blog.service';
import { BlogPost } from '../interface/blog.interface';

/**
 * Thunk to fetch all blog posts
 */
export const fetchBlogPosts = createAsyncThunk<BlogPost[], number | undefined>(
  'blog/fetchPosts',
  async (limit, { rejectWithValue }) => {
    try {
      const posts = await blogService.getPosts(limit);
      return posts;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch blog posts');
    }
  }
);

/**
 * Thunk to fetch a single blog post by slug
 */
export const fetchBlogPostBySlug = createAsyncThunk<BlogPost | null, string>(
  'blog/fetchPostBySlug',
  async (slug, { rejectWithValue }) => {
    try {
      const post = await blogService.getPostBySlug(slug);
      return post;
    } catch (error: any) {
      return rejectWithValue(error.message || `Failed to fetch blog post: ${slug}`);
    }
  }
);
